import React from 'react'
import { EventParentTypes } from '../../config'
import { RelativeTimestamp } from '../../components/ui/RelativeTimestamp'
import { MyHTMLTable } from '../../packages/blueprint-components/src/HTMLTable'
import { useTableHooks } from '../../packages/blueprint-components/src/useTableHooks'
import { AuditLog } from '../../components/audit_log/AuditLog'
import { Tooltip } from '../../components/ui/tooltip'
export const SinkAuditLogs = ({}) => {
    const smartBid: AuditLog = new AuditLog({
        id: 1,
        profile_id: 1,
        source_type_id: EventParentTypes.SmartBid,
        source_id: 0,
        target_type_id: EventParentTypes.KEYWORD,
        meta: {
            count: 3,
        },
        created_at: '2021-07-01T01:34:03.000000Z',
        updated_at: '2021-07-01T01:34:03.000000Z',
    })

    const promotion: AuditLog = new AuditLog({
        id: 2,
        profile_id: 1,
        source_type_id: EventParentTypes.Promotion,
        source_id: 123,
        target_type_id: EventParentTypes.AD_GROUP,
        meta: {
            count: 3,
            event: {
                promotion: {
                    id: 123,
                },
            },
        },
        created_at: '2021-07-01T01:34:03.000000Z',
        updated_at: '2021-07-01T01:34:03.000000Z',
    })

    const bulkAction: AuditLog = new AuditLog({
        id: 3,
        profile_id: 1,
        source_type_id: EventParentTypes.BulkAction,
        source_id: 0,
        target_type_id: EventParentTypes.TARGETS,
        meta: {
            count: 3,
            event: {
                filters: {},
                query: 'search string',
                actions: {},
                from: 'todo',
                to: 'todo',
            },
        },
        created_at: '2021-07-01T01:34:03.000000Z',
        updated_at: '2021-07-01T01:34:03.000000Z',
    })

    const load = () => {
        return Promise.resolve({
            data: {
                data: [smartBid, promotion, bulkAction],
                from: 1,
                to: 15,
                per_page: 15,
                last_page: 116,
                current_page: 1,
            },
        })
    }

    const tableHooks = useTableHooks(load)

    return (
        <div className="p-6">
            <Tooltip
                content={<pre className="bg-gray-100 p-2">{JSON.stringify(smartBid, null, 2)}</pre>}
            >
                Event
            </Tooltip>
            <div>Source Type: {smartBid.sourceType()}</div>
            <div>Effected Entities: {smartBid.effectedEntities()}</div>
            <div>Event: {smartBid.event()}</div>

            {/* @ts-ignore*/}
            <MyHTMLTable
                columns={[
                    {
                        key: 'source_id',
                        title: 'Source',
                        cell: (action: AuditLog) => action.sourceType(),
                    },
                    {
                        key: 'created_at',
                        title: 'Time',
                        cell: (action: AuditLog) => (
                            <RelativeTimestamp date={new Date(action.created_at)} />
                        ),
                    },
                    {
                        key: 'targets',
                        title: 'Affected Entities',
                        cell: (action: AuditLog) => action.effectedEntities(),
                    },
                    { key: ' ', title: 'Event', cell: (action: AuditLog) => action.event() },
                ]}
                empty={null}
                paginationClassname={null}
                htmlTableWrapperClassname={null}
                onSelectChange={() => {}}
                selectKey={null}
                showPerPage={false}
                {...tableHooks}
            />
        </div>
    )
}
